// removed by extract-text-webpack-plugin
module.exports = {"testimonialCardContainer":"testimonialCardContainer__3fC71","testimonialImage":"testimonialImage__22BnD","testimonialContent":"testimonialContent__2q7tu","testimonialDescription":"testimonialDescription__1n7x1"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-fast-feature/components/testimonials/testimonialCard/style.css
// module id = fD2t
// module chunks = 458